import {ToggleButton, ToggleButtonGroup} from '@mui/material';
import {useField, useFormikContext} from 'formik';
import {notEmpty} from 'main/utility/CommonUtil';
import PropTypes from 'prop-types';

const AppOptFldToggle = (props) => {
  const {options, optionalignment, multivalue: isMulti} = props;
  const [field] = useField(props);
  const {setFieldValue} = useFormikContext();

  const hasOptions = notEmpty(options);

  const handleChange = (_, newValue) => {
    if (newValue != null) {
      setFieldValue(field.name, newValue);
    }
  };

  return (
    <ToggleButtonGroup
      fullWidth
      name={field.name}
      value={field.value ?? (isMulti ? [] : '')}
      onChange={handleChange}
      orientation={optionalignment || 'horizontal'}
      exclusive={!isMulti}
    >
      {hasOptions &&
        options.map((option) => (
          <ToggleButton
            key={`${field.name}:${option.value}`}
            aria-label={option.label}
            value={option.value}
          >
            {option.label}
          </ToggleButton>
        ))}
    </ToggleButtonGroup>
  );
};

AppOptFldToggle.propTypes = {
  label: PropTypes.string,
  labelid: PropTypes.string,
  required: PropTypes.bool,
  multivalue: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.node.isRequired,
      value: PropTypes.any.isRequired,
    }),
  ).isRequired,
  optionalignment: PropTypes.oneOf(['horizontal', 'vertical']),
};

export default AppOptFldToggle;
